import { getDataTracker } from '@/integrations/trackingScripts/utils';
import { HTMLProps } from 'react';

export function returnRefAndGenerateDataTracker(
  ref: HTMLElement | null,
  forwardRef?: React.Ref<HTMLElement>
) {
  if (!ref || ref.dataset.tracker || ref.dataset.trackerIgnore) {
    return;
  }

  ref.dataset.tracker = getDataTracker(ref);

  if (typeof forwardRef === 'function') {
    forwardRef(ref as HTMLButtonElement);
  } else if (forwardRef) {
    (forwardRef as unknown as React.MutableRefObject<HTMLElement>).current =
      ref;
  }
}

export const passDataTrackerRef = <T extends HTMLElement>(
  ref?: React.Ref<T>
): Partial<HTMLProps<T>> => {
  if (typeof window === 'undefined') {
    return {};
  }

  return {
    ref: (_ref: any) => {
      returnRefAndGenerateDataTracker(_ref, ref);
    },
  };
};
